<template>
    <div class="BoxLinks">
        <router-link v-for="item of Object.values(items)" :to="{name: item.id}" class="BoxLinks-item">
            <img :src="item.icon" :alt="item.title">
            <span>{{ item.title }}</span>
        </router-link>
    </div>
</template>

<script>
export default {
	props: {
	    items: {
	    	type: Object,
	    	default: []
        }
    }
}
</script>

<style lang="scss" scoped>
.BoxLinks {
    display: flex;
    gap: 1.2em;
    flex-wrap: wrap;

    &-item {
        background: var(--colorBrand);
        color: #fff;
        font-size: var(--textXl);
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1 0 30%;
        max-width: calc(50% - 1.2em);
        padding: 1em;
        cursor: pointer;
        transition: all .25s ease-in-out;
        text-decoration: none;
        @media(max-width: 880px) {
            flex: 1 0 100%;
            max-width: none;
            padding: 1.5em 14%;
        }
        @media (max-width: 580px) {
            font-size: var(--textMd);
        }

        &:hover {
            background: var(--colorBrandDarken);
        }

        span {
            margin-left: 1em;
            @media (max-width: 580px) {
                flex: 1;
            }
        }

        img {
            width: 3.2em;
        }
    }
}
</style>